import React, { Component } from "react";
import { apiGet, apiPost, apiPut, apiDel } from '../api';
import CustomerTable from "./customer-table";

class CustomerList extends Component {
  state = {
    customers: [],
    customerDetail: null
  };

  constructor(params) {
    super(params);
    this.getCustomerDetail = this.getCustomerDetail.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.deleteCustomer = this.deleteCustomer.bind(this);
  }

  componentDidMount() {
    this.getCustomers();
  }

  async getCustomerDetail(customerId) {
    const customerDetail = await apiGet(`/customers/${customerId}`);
    this.setState({ customerDetail: customerDetail.data });
  }

  async getCustomers() {
    const customers = await apiGet("/customers");
    this.setState({ customers: customers.data });
  }

  async createCustomer(customer) {
    await apiPost("/customers", customer);
    await this.getCustomers();
  }

  async deleteCustomer(domain) {
    await apiDel(`/customers/${domain}`);
    await this.getCustomers();
  }

  render() {
    const { customers } = this.state;
    const { getCustomerDetail, createCustomer, deleteCustomer } = this;

    const params = {
      customers,
      getCustomerDetail,
      createCustomer,
      deleteCustomer
    };

    return <CustomerTable {...params} />;
  }
}
export default CustomerList;
